<template>
  <div>
    <stat-card
      title="Gross Profit"
      color="green accent-1"
      :amount="balanceTotal"
      icon="mdi-chart-multiple"
      sub_title=""
    ></stat-card>

    <stat-card
      title="GST on Gross Profit"
      color="green accent-1"
      :amount="balanceGST"
      icon="mdi-chart-multiple"
      sub_title=""
    ></stat-card>
  </div>
</template>

<script>
import axios from "axios";
import StatCard from "./StatCard.vue";

export default {
  components: {
    StatCard,
  },
  props: ["startDate", "endDate"],
  watch: {
    startDate() {
      this.loadRates();
    },
    endDate() {
      this.loadRates();
    },
  },
  created() {
    this.loadRates();
  },

  computed: {
    numberOfDays: function () {
      const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
      return (
        Math.round(
          Math.abs((new Date(this.endDate) - new Date(this.startDate)) / oneDay)
        ) + 1
      );
    },
    balanceTotal: function () {
      return this.formatSum(this.totalReceived - this.conSpend, "$");
    },
    balanceGST: function () {
      return this.formatSum(this.gstOnReceived - this.conSpendGST, "$");
    },
  },

  data: () => ({
    totalReceived: 0,
    gstOnReceived: 0,
    conSpend: 0,
    conSpendGST: 0,
    errors: [],
  }),

  methods: {
    loadRates() {
      axios
        .get(
          `/summary/totalreceived?startDate=${this.startDate}&endDate=${this.endDate}`
        )
        .then((response) => {
          this.totalReceived = response.data[0].SubTotal;
          this.gstOnReceived = response.data[0].GST;
        })
        .catch((e) => {
          this.errors.push(e);
        });

      axios
        .get(
          `/summary/totalconspend?startDate=${this.startDate}&endDate=${this.endDate}`
        )
        .then((response) => {
          this.conSpend = response.data[0].SubTotal;
          this.conSpendGST = response.data[0].GST;
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },
    formatSum(sum, prefix = "", decimal = 2) {
      sum = sum.toFixed(decimal);
      return (
        prefix + " " + sum.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      );
    },
  },
};
</script>

<style></style>
